import { deepValue, itemHasKey } from '@corratech/pylot-utils'
import { CartItemInterface, ProductInterface } from '@pylot-data/pylotschema'

const isCartItem = (
    item: CartItemInterface | ProductInterface
): item is CartItemInterface => {
    return itemHasKey(item, 'product')
}

// Get a longest breadcrumb path for a product
export const getCategories = (
    data: CartItemInterface | ProductInterface
): string => {
    const categoryList: string[] = []

    const categories = isCartItem(data)
        ? deepValue(data, ['product', 'categories'])
        : deepValue(data, ['categories'])

    if (!Array.isArray(categories) || categories.length === 0) {
        return ''
    }

    categories.forEach((item) => {
        categoryList.push(item.name)
    })

    return categoryList.join(',')
}
